import { get } from './requests'

export const getAvailableClasses = (key, params) => get(['new', 'classes'], { key, params })

export const getPublicClass = (key, classId) => get(['new', 'classes', classId], { key })
